import {
    AccordionVariant,
    BackgroundColor,
    ContainerDisplayVariant,
    ContentEnum,
    DisplaySectionName,
    DividerVariant,
    MosaicGalleryVariant,
    FooterVariant,
    PackageOptionsVariant,
    ReviewSectionVariant,
    TitleSectionVariant,
} from 'component/page/detail/DetailPageModularize/detailPageModularize.types';
import { DetailPageDisplayConfig, PACKAGE_OPTIONS_HREF } from 'component/page/detail/DetailPageModularize/contentRegistry.type';

export const genericDetailPageConfig: DetailPageDisplayConfig = {
    [DisplaySectionName.LandingPageTop]: {
        contents: [
            {
                content: ContentEnum.Breadcrumb,
                wrapperProps: {
                    display: ContainerDisplayVariant.None,
                },
                contentProps: {},
            },
            {
                content: ContentEnum.TitleSection,
                wrapperProps: {
                    display: ContainerDisplayVariant.None,
                    pb: '8',
                },
                contentProps: {
                    variant: TitleSectionVariant.NoThumbnail,
                },
            },
            {
                content: ContentEnum.MosaicGallery,
                wrapperProps: {
                    display: ContainerDisplayVariant.None,
                },
                contentProps: {
                    variant: MosaicGalleryVariant.Default,
                },
            },
        ],
        variant: {
            desktopPt: '0',
            desktopPb: '0',
            mobilePt: '0',
            mobilePb: '0',
        },
    },
    [DisplaySectionName.LandingPageMain]: {
        contents: [
            {
                content: ContentEnum.AtAGlance,
                wrapperProps: {
                    display: ContainerDisplayVariant.None,
                    pb: '8',
                },
                contentProps: {
                    isShowReadMoreButtonDisable: false,
                },
            },
            {
                content: ContentEnum.Highlight,
                wrapperProps: {
                    display: ContainerDisplayVariant.None,
                },
                contentProps: {},
            },
            {
                content: ContentEnum.TabsContentHandler,
                wrapperProps: {
                    display: ContainerDisplayVariant.None,
                },
                contentProps: {
                    contents: [
                        {
                            content: ContentEnum.VerticalContentHandler,
                            wrapperProps: {
                                display: ContainerDisplayVariant.None,
                            },
                            contentProps: {
                                href: PACKAGE_OPTIONS_HREF,
                                titleCms: 238726,
                                elementName: 'package-options-container',
                                contents: [
                                    {
                                        content: ContentEnum.PackageOptions,
                                        wrapperProps: {
                                            display: ContainerDisplayVariant.None,
                                            dividerVariant: DividerVariant.Line,
                                            pb: '16',
                                        },
                                        contentProps: {
                                            variant: PackageOptionsVariant.Default,
                                        },
                                    },
                                    {
                                        content: ContentEnum.ExploringActivitiesCarousel,
                                        wrapperProps: {
                                            display: ContainerDisplayVariant.None,
                                            pt: '24',
                                        },
                                        contentProps: {},
                                    },
                                ],
                            },
                        },
                        {
                            content: ContentEnum.SimCardSpec,
                            wrapperProps: {
                                display: ContainerDisplayVariant.Accordion,
                                accordionVariant: AccordionVariant.Collapsed,
                                dividerVariant: DividerVariant.Line,
                            },
                            contentProps: {},
                        },
                        {
                            content: ContentEnum.IntroductionSummary,
                            wrapperProps: {
                                display: ContainerDisplayVariant.Accordion,
                                accordionVariant: AccordionVariant.Collapsed,
                                dividerVariant: DividerVariant.Line,
                            },
                            contentProps: {},
                        },
                        {
                            content: ContentEnum.DepartureAndReturn,
                            wrapperProps: {
                                display: ContainerDisplayVariant.Accordion,
                                accordionVariant: AccordionVariant.Collapsed,
                                dividerVariant: DividerVariant.Line,
                            },
                            contentProps: {},
                        },
                        {
                            content: ContentEnum.WhatToExpect,
                            wrapperProps: {
                                display: ContainerDisplayVariant.Accordion,
                                accordionVariant: AccordionVariant.Collapsed,
                                dividerVariant: DividerVariant.Line,
                            },
                            contentProps: {},
                        },
                        {
                            content: ContentEnum.Location,
                            wrapperProps: {
                                display: ContainerDisplayVariant.Accordion,
                                accordionVariant: AccordionVariant.Collapsed,
                                dividerVariant: DividerVariant.Line,
                            },
                            contentProps: {},
                        },
                        {
                            content: ContentEnum.SuggestedRoute,
                            wrapperProps: {
                                display: ContainerDisplayVariant.Accordion,
                                accordionVariant: AccordionVariant.Collapsed,
                                dividerVariant: DividerVariant.Line,
                            },
                            contentProps: {},
                        },
                        {
                            content: ContentEnum.AdditionalInformation,
                            wrapperProps: {
                                display: ContainerDisplayVariant.Accordion,
                                accordionVariant: AccordionVariant.Collapsed,
                                dividerVariant: DividerVariant.Line,
                            },
                            contentProps: {},
                        },
                        {
                            content: ContentEnum.CancellationPolicy,
                            wrapperProps: {
                                display: ContainerDisplayVariant.Accordion,
                                accordionVariant: AccordionVariant.Collapsed,
                                dividerVariant: DividerVariant.Line,
                            },
                            contentProps: {},
                        },
                        {
                            content: ContentEnum.FAQs,
                            wrapperProps: {
                                display: ContainerDisplayVariant.Accordion,
                                accordionVariant: AccordionVariant.Collapsed,
                                dividerVariant: DividerVariant.Line,
                            },
                            contentProps: {},
                        },
                        {
                            content: ContentEnum.AboutActivity,
                            wrapperProps: {
                                display: ContainerDisplayVariant.Accordion,
                                accordionVariant: AccordionVariant.Collapsed,
                                dividerVariant: DividerVariant.Line,
                            },
                            contentProps: {},
                        },
                        {
                            content: ContentEnum.ReviewSection,
                            wrapperProps: {
                                display: ContainerDisplayVariant.Accordion,
                                accordionVariant: AccordionVariant.Expanded,
                            },
                            contentProps: {
                                variant: ReviewSectionVariant.OverviewOnMobile,
                            },
                        },
                    ],
                },
            },
        ],
        variant: {
            backgroundColor: BackgroundColor.WHITE,
            desktopPt: '32',
            desktopPb: '12',
            mobilePt: '16',
            mobilePb: '12',
            footerVariant: FooterVariant.Default,
        },
    },
    [DisplaySectionName.InfoOverlay]: {
        contents: [],
    },
};
